// @ts-nocheck
import * as types from '../types';

const initialState = {
    list: [],
    drawer: {
        data: {},
        isVisible: false,
    },
};

const bettingRules = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.BETTING_RULES_LIST_CHANGED: {
            return {
                ...state,
                list: payload,
            };
        }
        case types.BETTING_RULES_DRAWER_PROPS_CHANGED: {
            return {
                ...state,
                drawer: payload,
            };
        }
        default:
            return state;
    }
};

export default bettingRules;
